import {useEffect, useEffectEvent} from 'react';

import type {CreateBuyerFormValues} from '../validation';
import type {UseFormReturn} from 'react-hook-form';

/** Inactive rows are hidden, so RHF can't focus their invalid field — surface the first invalid row instead. */
export function useSelectFirstInvalidBuyer(
  form: UseFormReturn<CreateBuyerFormValues>,
  select: (index: number) => void
): void {
  const {submitCount} = form.formState;

  const selectFirstInvalid = useEffectEvent(() => {
    const buyerErrors = form.formState.errors.buyers;
    const firstInvalid = Array.isArray(buyerErrors) ? buyerErrors.findIndex(Boolean) : -1;
    if (firstInvalid >= 0) select(firstInvalid);
  });

  useEffect(() => {
    if (submitCount > 0) selectFirstInvalid();
  }, [submitCount]);
}
